"use client"
import {useEffect, useState} from "react";
import { formatMomentStyle } from "@/helpers/dateUtils";

export default function FormattedDate(
  {
    dateTimeString,
    format = "LLL"
  }: {
    dateTimeString: string;
    format?: string;
  }
) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  return (
    <time dateTime={mounted ? dateTimeString : ''}>
      {mounted ? formatMomentStyle(dateTimeString, format) : 'Loading...'}
    </time>
  );
}